'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
V1.2
Problemen met de rendering van een icoon in bepaalde resolutie.
Probeer d.m.v. van CSS en media-queries een stroke toe tevoegen.
Wil je halve pixels gebruiken
-moz-transform: translate3d(0,0,0);
-ms-transform: translate3d(0,0,0);
-webkit-transform: translate3d(0,0,0);
transform: translate3d(0,0,0);
Een andere optie is het icoon dubbel toevoegen.


sprite maken in illustrator:
Werken met een pixel grid en lijn de iconen hierop uit
Kleuren op rgb/rgba zetten
Geef elk icoon een aparte groep en geef deze een naam, word de ID naam.
Sla iconen zoveel mobelijk dicht met 'compound path'.
*/

var x, y, id;

$.fn.icons = function (options) {

	options = $.extend({
		svg: 'sprite.svg',
		offset: 2,
		ajax: true,
		testFallback: false,
		ready: function ready(prop) {}
	}, options);

	var body = $(this),
	    prop = {},
	    sprites = [],
	    gObjectsTypes = 'circle, ellipse, line, polyline, polygon, path, text';

	var idCounter = 0;
	function uniqueId() {
		var id = 'svg-icon-' + idCounter;
		idCounter++;
		return id;
	}

	function makeArray(value) {
		var arr = value.split(',');
		for (var i = 0; i < arr.length; i++) {
			arr[i] = arr[i].trim();
		}
		return arr;
	}

	function removeOldKeys() {
		for (id in prop) {
			if ($('#' + id).length == '') {
				delete prop[id];
			}
		}
	}

	function getSprite(svg, callback) {
		if (sprites[svg] == undefined) {
			$.get(svg, null, function (sprite) {
				var sprite = sprite.getElementsByTagName('svg'),
				    sprite = document.adoptNode(sprite[0]);
				sprites[svg] = sprite;
				callback(sprites[svg]);
			}, 'xml');
		} else {
			callback(sprites[svg]);
		}
	}

	function appendIconsToDom(svg, icons, elements) {
		if (Modernizr.svg && options.testFallback == false) {
			getSprite(svg, function (svg) {
				/* $.get(svg, null, function(svg) {
    	var svg = svg.getElementsByTagName('svg');
    	var svg = document.adoptNode(svg[0]);
    	*/
				if (icons.constructor != Array) {
					icons = [icons];
				}
				for (var i = 0; i < elements.length; i++) {
					var icon = icons[i];
					if (icon.substring(0, 1) != '#') {
						icon = '#' + icon;
					}
					var icon = svg.querySelector(icon).cloneNode(true);
					// var svgCanvas = '<svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 100 100" xml:space="preserve"></svg>';
					var svgCanvas = '<svg x="0px" y="0px" width="100%" height="100%" viewBox="0 0 100 100"></svg>';
					var id = uniqueId();
					elements[i].html(svgCanvas);
					elements[i].find('svg').html(icon);
					if (elements[i].find('svg g').length != '') {
						elements[i].attr('id', id);
						elements[i].addClass('loaded');
						prop[id] = {
							id: id,
							item: elements[i],
							data: {},
							bbox: {},
							manipulate: {},
							fallback: {}
						};
						getIconData(id);
						manipulateIcon(prop[id]);
						$.isFunction(options.ready) && options.ready.call(body, prop[id]);
					}
				}
				// },'xml');
			});
		} else {
			for (var i = 0; i < elements.length; i++) {
				var icon = icons[i];
				var id = uniqueId();
				prop[id] = {
					item: elements[i],
					fallback: {}
				};
				elements[i].addClass('loaded');
				fallbackIcon(id);
			}
		}
	}

	function getIconData(id) {
		var $this = prop[id].item;
		if ($this.css('display') == 'none') {
			prop[id].manipulate.hidden = true;
			$this.show();
		}
		if ($this.is(":visible")) {
			prop[id].bbox = $this.find('svg g')[0].getBBox();
		}
		// data-icon="ID"
		if (typeof $this.data('icon') !== 'undefined') {
			prop[id].data.icon = $this.data('icon');
		} else {
			delete prop[id];
		}
		// data-sprite="url"
		if (typeof $this.data('sprite') !== 'undefined') {
			prop[id].data.sprite = $this.data('sprite');
		} else {
			prop[id].data.sprite = options.svg;
		}
		// data-offset="[NUM]" offset inside svgBBox.
		if (typeof $this.data('offset') !== 'undefined') {
			prop[id].manipulate.offset = $this.data('offset');
		} else {
			prop[id].manipulate.offset = options.offset;
		}
		// data-rotate="[deg]" 0 tot 360, 0 tot -360
		if (typeof $this.data('rotate') !== 'undefined') {
			prop[id].manipulate.rotate = $this.data('rotate');
		}
		// data-fill="#000000, #fffffff" of komma gescheiden voor meerdere kleuren
		if (typeof $this.data('fill') !== 'undefined') {
			var fill = makeArray($this.data('fill') + '');
			prop[id].manipulate.fill = fill;
		}
		// data-stroke="2" of komma gescheiden voor meerdere stroke-diktes
		if (typeof $this.data('stroke') !== 'undefined') {
			var stroke = makeArray($this.data('stroke') + '');
			prop[id].manipulate.stroke = stroke;
		}
		// data-stroke-width="#000000" of komma gescheiden voor meerdere stroke-kleuren.
		if (typeof $this.data('stroke-width') !== 'undefined') {
			var strokeWidth = makeArray($this.data('stroke-width') + '');
			prop[id].manipulate.strokeWidth = strokeWidth;
		}
		// data-opacity="0.5" 0 tot 1.
		if (typeof $this.data('opacity') !== 'undefined') {
			prop[id].manipulate.opacity = $this.data('opacity');
		}
		// data-shadow="5 5 2 rgba(0,0,0,0.5)" x y size color (geen px of em definieren)
		if (typeof $this.data('shadow') !== 'undefined') {
			var shadow = $this.data('shadow').replace(/\s\s+/g, ' ').split(' ');
			for (var i = 0; i < shadow.length; i++) {
				if (shadow[i] == '') {
					delete shadow[i];
				} else {
					shadow[i] = shadow[i].trim();
				}
			}
			for (var i = 0; i < 3; i++) {
				shadow[i] = shadow[i].replace('px', '');
			}
			prop[id].manipulate.shadow = shadow;
		}
	}

	function manipulateIcon($this) {
		if ($this.item.is(":visible")) {
			var offset = $this.manipulate.offset;
			x = Math.ceil($this.bbox.x * 10) / 10 - offset / 2, y = Math.ceil($this.bbox.y * 10) / 10 - offset / 2, width = Math.ceil($this.bbox.width * 10) / 10 + offset, height = Math.ceil($this.bbox.height * 10) / 10 + offset;
			$this.item.find('svg')[0].setAttribute('viewBox', +x + ' ' + y + ' ' + width + ' ' + height);
			if ($this.manipulate.rotate) {
				if (Modernizr.csstransforms) {
					var angle = $this.manipulate.rotate,
					    width = Math.round(($this.bbox.x + $this.bbox.width / 2) * 10) / 10,
					    height = Math.round(($this.bbox.y + $this.bbox.height / 2) * 10) / 10;
					$this.item.find('svg g')[0].setAttribute("transform", "rotate(" + angle + " " + width + " " + height + ")");
				} else {
					$this.item.html('');
					fallbackIcon($this.item.attr('id'));
					return false;
				}
			}
			if ($this.manipulate.fill) {
				var objects = $this.item.find(gObjectsTypes).length;
				if ($this.manipulate.fill[1]) {
					for (var i = 0; i < objects; i++) {
						$this.item.find(gObjectsTypes)[i].setAttribute('fill', $this.manipulate.fill[i]);
					}
				} else {
					for (var i = 0; i < objects; i++) {
						$this.item.find(gObjectsTypes)[i].setAttribute('fill', $this.manipulate.fill[0]);
					}
				}
			}
			if ($this.manipulate.stroke) {
				var icon = $this.item.find('svg g').clone();
				$this.item.find('svg').append(icon);
				var objects = $this.item.find('g').first().find(gObjectsTypes).length;
				if ($this.manipulate.stroke[1]) {
					for (i = 0; i < objects; i++) {
						$this.item.find('g').first().find(gObjectsTypes)[i].setAttribute('stroke', $this.manipulate.stroke[i]);
					}
				} else {
					for (i = 0; i < objects; i++) {
						$this.item.find('g').first().find(gObjectsTypes)[i].setAttribute('stroke', $this.manipulate.stroke[0]);
					}
				}
			}
			if ($this.manipulate.strokeWidth) {
				var objects = $this.item.find('g').first().find(gObjectsTypes).length;
				if ($this.manipulate.strokeWidth[1]) {
					for (i = 0; i < objects; i++) {
						$this.item.find('g').first().find(gObjectsTypes)[i].setAttribute('stroke-width', $this.manipulate.strokeWidth[i]);
					}
				} else {
					for (i = 0; i < objects; i++) {
						$this.item.find('g').first().find(gObjectsTypes)[i].setAttribute('stroke-width', $this.manipulate.strokeWidth[0]);
					}
				}
			}
			if ($this.manipulate.opacity) {
				$this.item.find('g')[0].setAttribute('opacity', $this.manipulate.opacity);
			}
			if ($this.manipulate.shadow) {
				var filter = '<filter id="drop-shadow" width="200%" height="200%">';
				filter += '<feGaussianBlur in="SourceAlpha" stdDeviation="' + $this.manipulate.shadow[2] + '"/>'; // size
				filter += '<feOffset dx="' + $this.manipulate.shadow[0] + '" dy="' + $this.manipulate.shadow[1] + '" result="offsetblur"/>'; // offset x, y
				filter += '<feFlood flood-color="' + $this.manipulate.shadow[3] + '"/>'; // color
				filter += '<feComposite in2="offsetblur" operator="in"/>';
				filter += '<feMerge>';
				filter += '<feMergeNode/>';
				filter += '<feMergeNode in="SourceGraphic"/>';
				filter += '</feMerge>';
				filter += '</filter>';
				$this.item.find('svg').prepend(filter);
				var objects = $this.item.find('g').first().find(gObjectsTypes).length;
				for (i = 0; i < objects; i++) {
					$this.item.find('g').find(gObjectsTypes)[i].setAttribute('filter', 'url(#drop-shadow)');
				}
				$this.item.html($this.item.html());
			}
			if ($this.manipulate.hidden == true) {
				$this.item.hide();
			}
		} else {
			$this.item.removeClass('loaded');
		}
	}

	function fallbackIcon(id) {
		var $this = prop[id];
		if (typeof $this.item.data('fallback') !== 'undefined' && typeof $this.item.data('fallback-pos') !== 'undefined') {
			$this.fallback.background = $this.item.data('fallback');
			var pos = makeArray($this.item.data('fallback-pos'));
			$this.fallback.x = pos[0];
			$this.fallback.y = pos[1];
			$this.item.css({ 'background': 'url(' + $this.fallback.background + ') ' + $this.fallback.x + ' ' + $this.fallback.y });
		} else {
			return false;
		}
	}

	$.fn.icons.init = function ($class, $container) {
		if ($container != false && $container !== undefined && $container !== null) {
			if ((typeof container === 'undefined' ? 'undefined' : _typeof(container)) != 'object') {
				$container = $($container);
			}
		} else {
			$container = $('body');
		}
		if (options.ajax == true) {
			removeOldKeys();
		}
		var icons = {},
		    elements = {};
		$container.find($class).each(function () {
			var iconId = $(this).attr('data-icon');
			if (iconId != '' && typeof iconId != 'undefined' && !$(this).hasClass('loaded')) {
				var sprite = $(this).attr('data-sprite');
				if (sprite == '' || typeof sprite === 'undefined') {
					sprite = options.svg;
				}
				if (sprite in icons) {
					icons[sprite].push(iconId);
					elements[sprite].push($(this));
				} else {
					icons[sprite] = [iconId];
					elements[sprite] = [$(this)];
				}
			}
		});
		for (var key in icons) {
			appendIconsToDom(key, icons[key], elements[key]);
		}
	};
};